import * as types from '../actions/actionTypes';
import initialState from './initialState';
        
        
export default function formularioReducer(state= initialState.formulario, action){
    let newState;
	switch(action.type){
        case types.LOAD_FORMULARIO_LIST_SUCCESS:
            action.formulario.filtroActivo=state.filtroActivo;
            action.formulario.filtroActual=state.filtroActual;
            action.formulario.showActivos=state.showActivos;
            action.formulario.paginaActual=action.formulario.pageable.pageNumber;
            action.formulario.registrosPorPagina=action.formulario.size;
            return action.formulario;

        case types.BORRAR_FORMULARIO_SUCCESS:		            
            newState=Object.assign({}, state);
            newState.content=[...state.content.filter(formulario => formulario.id !== action.formulario.id)];          
			return newState;    
            
        case types.ACTIVAR_FORMULARIO_SUCCESS:		            
            newState=Object.assign({}, state);
            newState.content=[...state.content.filter(formulario => formulario.id !== action.formulario.id)];          
            return newState;
            
        case types.SET_FILTRO_FORMULARIO:
			newState=Object.assign({}, state);
			newState.filtroActivo=action.filtro.filtroActivo;
			newState.filtroActual=action.filtro.filtroActual;
            newState.showActivos=action.filtro.showActivos;
            
            
			return newState;
		break;
            
		default:
			return state;
	}
}